/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Merge
 */
export interface Merge {
    /**
     * 
     * @type {string}
     * @memberof Merge
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Merge
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Merge
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Merge
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof Merge
     */
    profile?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Merge
     */
    method?: string;
    /**
     * 
     * @type {string}
     * @memberof Merge
     */
    controlOrder?: string;
}

/**
 * Check if a given object implements the Merge interface.
 */
export function instanceOfMerge(value: object): value is Merge {
    return true;
}

export function MergeFromJSON(json: any): Merge {
    return MergeFromJSONTyped(json, false);
}

export function MergeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Merge {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'method': json['method'] == null ? undefined : json['method'],
        'controlOrder': json['controlOrder'] == null ? undefined : json['controlOrder'],
    };
}

export function MergeToJSON(json: any): Merge {
    return MergeToJSONTyped(json, false);
}

export function MergeToJSONTyped(value?: Merge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'profile': value['profile'],
        'method': value['method'],
        'controlOrder': value['controlOrder'],
    };
}

